import { Link } from "react-router-dom";
import { footerDisclaimer, site } from "@/mocks/site-data";

export default function Footer() {
  return (
    <footer className="bg-background-100 text-foreground-400">
      <div className="mx-auto max-w-8xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-accent-400/70">
                <img
                  src="https://public.readdy.ai/ai/img_res/fe4adf6c-5bca-46d7-9c2e-e5888e9d0642.png"
                  alt="Logo Dra. Sâmia Albuquerque"
                  className="h-7 w-7 object-contain"
                />
              </span>
              <div className="flex flex-col leading-tight">
                <span className="font-heading text-xl font-semibold text-foreground-50">
                  Dra. Sâmia Albuquerque
                </span>
                <span className="text-xs text-foreground-400">Médica — {site.crm}</span>
              </div>
            </div>
            <p className="mt-4 text-sm text-foreground-400">{site.location}</p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-accent-400 font-semibold">
              Contato
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href={site.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-foreground-400 transition-colors hover:text-accent-400"
                >
                  <i className="ri-instagram-line text-base" />
                  {site.instagramHandle}
                </a>
              </li>
              <li>
                <a
                  href={site.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-foreground-400 transition-colors hover:text-accent-400"
                >
                  <i className="ri-whatsapp-line text-base" />
                  WhatsApp: {site.whatsappDisplay}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-accent-400 font-semibold">
              Links
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link
                  to="/privacidade"
                  className="text-foreground-400 transition-colors hover:text-accent-400"
                >
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link
                  to="/termos"
                  className="text-foreground-400 transition-colors hover:text-accent-400"
                >
                  Termos de Uso
                </Link>
              </li>
              <li>
                <a
                  href={site.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-foreground-400 transition-colors hover:text-accent-400"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href={site.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-foreground-400 transition-colors hover:text-accent-400"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-secondary-400/50 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">{footerDisclaimer}</p>
        </div>

        <div className="mt-6 flex flex-col gap-2 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Dra. Sâmia Albuquerque. Todos os direitos reservados.</p>
          <p>Fortaleza–CE · Atendimento mediante agendamento</p>
        </div>
      </div>
    </footer>
  );
}